import { gql } from '@apollo/client';

export const GET_COURSE_BY_ID = gql`
  query GetCourseById($id: Uuid!) {
    courses(where: { id: { _eq: $id } }) {
      id
      openedxCourseId
      courseTags {
        tag
      }
      details: _CourseOverviewsCourseoverview {
        displayName
        courseImageUrl
        effort
      }
    }
  }
`;

export const GET_COURSE_DETAIL_BY_OPENEDX_ID = gql`
  query GetCourseDetailByOpenedxId($courseId: Text!) {
    courses(where: { openedxCourseId: { _eq: $courseId } }) {
      id
      openedxCourseId
      inviteOnly
      subscriptionOnly
      published
      courseTags {
        tag
      }
      details: _CourseOverviewsCourseoverview {
        id
        displayName
        displayNumberWithDefault
        courseImageUrl
        effort
        shortDescription
        start
        endDate
        enrollmentStart
        enrollmentEnd
      }
      modes: _CourseModesCoursemode(order_by: { minPrice: Asc }) {
        modeSlug
        minPrice
        modeDisplayName
        currency
        expirationDatetime
      }
      modeDetails: upsellCourseModes {
        courseMode
        description
        visible
        upsellableCourseModes
      }
      # A track earns a certificate when it is mapped to a template here, so
      # this is the only signal for "which plan gets me the certificate".
      courseCertificates {
        mode
      }
    }
  }
`;
